import { call, put, takeLatest } from "redux-saga/effects";

import { OverallCostAction } from "../actions";

import * as types from "../actions/actionTypes";

import queryString from "query-string";
import moment from "jalali-moment";
import { createBrowserHistory } from "history";
import * as overallCostApi from "../api/overallCost";
import { toastr } from "react-redux-toastr";
import checkErrorMessagesExist from "../assets/checkErrorMessagesExist";

moment.locale("fa");
export function* watcherOverallCost() {
  yield takeLatest(types.API_CALL_OVERALL_COST_REQUEST, worker);
}

async function fetchList(separation_type, pageNumber = null) {
  const page_number = pageNumber ? pageNumber : "";
  const history = createBrowserHistory();
  const filters = {
    file_type: "web",
    type: separation_type,
    sort_field: "amount",
    sort_type: "desc",
    routes: [],
    text_search: ""
  };

  let urlFilters = await queryString.parse(document.location.search);

  let parsed = {
    ...urlFilters
  };
  const search = await queryString.stringify(parsed);
  const oldSearch = history.location.search.substring(
    1,
    history.location.search.length
  );
  if (history.location.search !== "" && oldSearch !== search) {
    history.push({ search: `?${search}` });
  }
  urlFilters = {
    ...urlFilters,
    routes:
      urlFilters.routes !== undefined && urlFilters.routes !== ""
        ? urlFilters.routes.split("~").map(item => {
            let par = item.split(".");
            let id = par[0];
            let type = par[1];
            return { id, type };
          })
        : filters.routes
  };
  const finalFilter = { ...filters, ...urlFilters };
  return overallCostApi.getList(page_number, finalFilter);
}

function* worker(action) {
  try {
    const response = yield call(
      fetchList,
      action.separation_type,
      action.pageNumber
    );
    yield put(OverallCostAction.getSuccess(response.data));
  } catch (error) {
    // dispatch a failure action to the store with the error
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });

    yield put(OverallCostAction.getFailure(error));
  }
}
